import { useNavigate } from "react-router-dom";
import { Flame, Tent, ArrowRight } from "lucide-react";
import { HOMEPAGE } from "@/constants/testIds";

export default function Home() {
  const navigate = useNavigate();

  return (
    <div className="relative min-h-screen w-full overflow-hidden bg-black text-white flex items-center justify-center">
      <div
        className="absolute inset-0 bg-cover bg-center scale-105"
        style={{
          backgroundImage:
            "url('https://images.pexels.com/photos/12372756/pexels-photo-12372756.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1000&w=1400')",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/70 to-black" />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_20%,rgba(249,115,22,0.15),transparent_60%)]" />

      <div className="relative z-10 flex flex-col items-center text-center px-6 py-24 max-w-2xl">
        <div className="flex items-center gap-2 text-orange-400 mb-6 animate-[fadeIn_0.8s_ease-out]">
          <Tent className="w-5 h-5" />
          <span className="uppercase tracking-[0.25em] text-xs font-semibold">
            BPK Oi Jakarta Barat
          </span>
          <Tent className="w-5 h-5" />
        </div>

        <h1
          className="text-5xl sm:text-6xl lg:text-7xl font-bold leading-[0.95] mb-3"
          style={{ fontFamily: "'Anton', sans-serif" }}
        >
          <span className="bg-gradient-to-b from-amber-300 via-orange-500 to-orange-700 bg-clip-text text-transparent">
            JAMBORE V
          </span>
        </h1>
        <p className="text-lg sm:text-xl text-orange-100/90 font-medium mb-1">
          Mengabdi Dengan Hati
        </p>
        <p className="text-sm sm:text-base text-white/60 mb-10">
          31 Okt &ndash; 1 Nov 2026 &bull; Puncak, Bogor
        </p>

        <button
          data-testid={HOMEPAGE.ctaButton}
          onClick={() => navigate("/barat")}
          className="group relative inline-flex items-center gap-3 rounded-full bg-orange-600 hover:bg-orange-500 text-white font-bold px-8 py-4 text-base sm:text-lg transition-all duration-300 shadow-[0_0_40px_rgba(234,88,12,0.5)] hover:shadow-[0_0_60px_rgba(234,88,12,0.7)] hover:-translate-y-0.5 active:translate-y-0"
        >
          <Flame className="w-5 h-5 group-hover:scale-110 transition-transform" />
          Daftar Jambore Oi Jakbar Sekarang
          <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
        </button>

        <p className="mt-6 text-xs text-white/40">
          Rp50.000/orang &bull; Kuota terbatas
        </p>
      </div>
    </div>
  );
}
